export function challengeWireBadgeCount(summary) {
	return (summary?.pending_challenges || 0) + (summary?.active_challenges || 0);
}

export function landingDestinationBadgeCount(destination, summary) {
	if (destination.badgeKey === 'challenges') {
		return challengeWireBadgeCount(summary);
	}
	return 0;
}

export function trainerBriefingBadgeCount(summary) {
	return summary?.trainer_briefings || 0;
}
